import { createProvider } from '@nvision/services/data-provider';

import type { DirectInterlineFilters } from '../../models';
import * as api from './api';
import { normalizeDirectInterlineFilters, normalizeDirectInterlines } from './normalize';

export const fetchDirectInterlines = createProvider(
  (filters: Partial<DirectInterlineFilters>, { signal }: { signal?: AbortController['signal'] } = {}) =>
    api.fetchDirectInterlines(normalizeDirectInterlineFilters(filters), { signal }),
).andThen((res) => normalizeDirectInterlines(res));
